/**
 * "Proposer une idée" opens a Google Form in the user's language, in the in-app
 * browser, with their email pre-filled (still editable). Long docs.google.com
 * URLs: forms.gle short links drop the pre-fill params. Unknown language →
 * English, like the translation hook. Bugs go to Sentry instead.
 */
const FEEDBACK_FORMS = {
  fr: 'https://docs.google.com/forms/d/e/1FAIpQLSe-mx5ITg0NRUGhWtU162Ck3tG9e184brvWhEBJf7F0zCxsfA/viewform',
  en: 'https://docs.google.com/forms/d/e/1FAIpQLSe2PR8fILJShohHuz8V096XBiDX7JDyXWeW_XJSlL_DFvKphQ/viewform',
};
/** Same "email" question id in both forms. */
const EMAIL_ENTRY = 'entry.2071428445';

export function feedbackFormUrl(
  language: string | null | undefined,
  email?: string | null,
): string {
  const form = language === 'fr' ? FEEDBACK_FORMS.fr : FEEDBACK_FORMS.en;
  if (!email) return form;
  return `${form}?${new URLSearchParams({ usp: 'pp_url', [EMAIL_ENTRY]: email })}`;
}
